export default __webpack_public_path__ + "static/media/blog02.27eced82.jpg";